import { HOST_NAME } from '@/config/endpoints';
import { env } from '@/config/env';

export const getPhase = () => {
  const { hostname } = window.location;

  if (hostname === HOST_NAME.PROD) {
    return 'PROD';
  }
  if (hostname === HOST_NAME.BETA) {
    return 'BETA';
  }
  if (hostname === HOST_NAME.ALPHA) {
    return 'ALPHA';
  }
  return 'ALPHA';
};

export const getBaseURL = () => {
  const { hostname } = window.location;

  if (hostname === HOST_NAME.PROD) {
    return `https://${HOST_NAME.PROD}`;
  }
  if (hostname === HOST_NAME.BETA) {
    return `https://${HOST_NAME.BETA}`;
  }
  if (hostname === HOST_NAME.ALPHA) {
    return `https://${HOST_NAME.ALPHA}`;
  }
  return env.API_URL;
};
